module.exports = __webpack_public_path__ + "media/images/undraw_filter_4kje-e2057be47610efba98dbe8bd1497dc34.svg";